var app = angular.module('component-spinner',[]);
require('./directives/directive.js');
require('./stylesheet/index.scss');
require('./stylesheet/spinner.scss');
module.exports = app;


/*****************
 ** WEBPACK FOOTER
 ** ./app/directives/loader/index.js
 ** module id = 169
 ** module chunks = 1
 **/